"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _big = _interopRequireDefault(require("big.js"));

var calc = {
  '+': function _() {
    var arg = Array.prototype.slice.call(arguments);
    return arg.reduce(function (total, num) {
      return new _big["default"](total).plus(new _big["default"](num));
    }).toString() * 1;
  },
  '-': function _() {
    var arg = Array.prototype.slice.call(arguments);
    return arg.reduce(function (total, num) {
      return new _big["default"](total).minus(new _big["default"](num));
    }).toString() * 1;
  },
  '*': function _() {
    var arg = Array.prototype.slice.call(arguments);
    return arg.reduce(function (total, num) {
      return new _big["default"](total).times(new _big["default"](num));
    }).toString() * 1;
  },
  '/': function _() {
    var arg = Array.prototype.slice.call(arguments);
    return arg.reduce(function (total, num) {
      return new _big["default"](total).div(new _big["default"](num));
    }).toString() * 1;
  }
};
var _default = {
  calc: calc
};
exports["default"] = _default;